import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  MarkAsReviewedMutation,
  MarkAsReviewedMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const MARK_AS_REVIEWED_MUTATION = graphql(`
  mutation markAsReviewed($docId: String!) {
    markAsReviewed(docId: $docId) {
      id
      reviewDueDate
    }
  }
`);

export function useMarkDocumentAsReviewed(
  options?: UseMutationOptions<
    MarkAsReviewedMutation,
    unknown,
    MarkAsReviewedMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(MARK_AS_REVIEWED_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      // TODO: ideally we want to update cache directly here
      // In the To Review section in ContentLibraryNavigation.tsx, we only display documents that are due/overdue
      // so we'll need to remove the document from the list and decrease the totalCount by 1 for the query on that page
      await queryClient.invalidateQueries({ queryKey: ["customerDocuments"] });
      options?.onSuccess?.(data, variables, context);
    },
  });

  return { data: data?.markAsReviewed, ...rest };
}
